import React from 'react';

import { snackbar } from '@occc-app/design-system';
import copies from '@occc-app/routes/CampaignComponents/copies';
import { Flow_Types, FormContainerProps } from '@occc-app/offerHelpers/types';
import { CampaignComponentTabs } from '@occc-app/routes/CampaignComponents/components/ConfigurationLayout';

import { useGetDesignFormProps } from './hooks';
import { DesignForm } from './DesignForm';

export const DesignFormContainer: React.FC<FormContainerProps> = ({
  offer,
  type,
  offerId,
  onRefetchOffer,
  setTabValue,
  onCancel,
  onError,
  offerLoading,
  currentFlowType,
  showExternalUrl = false,
  showSurgeonGeneralsWarning = true,
  showOrderAheadToggle = false,
}) => {
  const onFormSubmitted = async () => {
    await onRefetchOffer();
    snackbar.success(copies.onSubmitSuccessToastMessage);

    if (currentFlowType === Flow_Types.Configure) {
      setTabValue(CampaignComponentTabs.Schedule);
    }
  };

  const onNextStepButtonClick = () => {
    setTabValue(CampaignComponentTabs.Schedule);
  };

  const designFormProps = useGetDesignFormProps({
    offer,
    type,
    offerId,
    offerLoading,
    currentFlowType,
    onError,
    onCancel,
    onFormSubmitted,
    orderAheadEnabled: showOrderAheadToggle,
  });

  return (
    <DesignForm
      {...designFormProps}
      showExternalUrl={showExternalUrl}
      orderAheadEnabled={showOrderAheadToggle}
      onNextStepButtonClick={onNextStepButtonClick}
      showSurgeonGeneralsWarning={showSurgeonGeneralsWarning}
    />
  );
};
